// helpers/parseDateTime.js
export default function parseDateTime(datetime) {
	if (!datetime) return null;

	// Разделяем дату и время
	const [ datePart, timePart ] = datetime.split(" ");
	if (!datePart || !timePart) return null;

	// Проверяем есть ли секунды
	const timeWithSeconds = timePart.length === 8 ? timePart : null;
	const timeWithoutSeconds = timePart.length >= 5 ? timePart.slice(0, 5) : null;

	return {
		date: datePart, // "2025-08-22"
		timeWithSeconds: timeWithSeconds, // "00:51:00" или null
		timeWithoutSeconds: timeWithoutSeconds // "00:51"
	};
}
